module.exports = __webpack_public_path__ + "media/fx-evening.19b79dc6.mp3";